import { List } from 'immutable';
import { filterViewMembers } from './filterViewMembers';
//TODO type this properly in a follow up PR
export const isThreadListMemberFiltered = (member, filters) => {
  const memberAsList = List([member]);
  const isFiltered = !filterViewMembers(memberAsList, filters).size;
  return isFiltered;
};